import { of } from 'rxjs';
import Global from '../../../store/global-selectors';
import { ModalService } from 'ui-components/services/modal-service';
import { LabelBatchStatusContainer } from '../../../components/modals/label-batch-status/open-batch.container';
import * as PostagePurchaseActions from '../../../store/postage-purchase/postage-purchase.actions';
import * as Actions from './batches.purchase.actions';
import { removeFulfillmentPlansFromBatch } from '../../../store/batches/details/batch.details.actions';
import { batchesErrorsAndWarningsResolution } from './batches.purchase.observables';

export const getAggregatedCostReviewData = (state, jobGuids) => {
  const costReviewParts = jobGuids.map((id) => Global.selectEntitiesBatchJobByJobId(state, { jobId: id })).map((job) => job.costReviewData);

  // Aggregate all the providers summaries together into one array
  const aggregatedProviderSummaries = costReviewParts
    .map((part) => part.providerCosts)
    .reduce((flattendProviders, providers) => [...flattendProviders, ...providers], [])
    .reduce((summaries, provider) => {
      const existingProviderSummary = summaries.find((summary) => summary.sellerLabelProviderId === provider.sellerLabelProviderId);
      if (!existingProviderSummary) {
        summaries.push(provider);
        return summaries;
      }
      existingProviderSummary.subTotal += provider.subTotal;
      existingProviderSummary.services.push(...provider.services);
      return summaries;
    }, []);

  // Aggregate all common services within a provider summary
  const providerCosts = aggregatedProviderSummaries.map((summary) => {
    const { services } = summary;
    const updatedServices = services.reduce((serviceSummaries, service) => {
      const existingServiceSummary = serviceSummaries.find(
        (serviceSummary) =>
          serviceSummary.shippingServiceId === service.shippingServiceId &&
          serviceSummary.sellerLabelProviderId === service.sellerLabelProviderId,
      );
      if (!existingServiceSummary) {
        serviceSummaries.push(service);
        return serviceSummaries;
      }
      existingServiceSummary.subTotal += service.subTotal;
      return serviceSummaries;
    }, []);

    return {
      ...summary,
      services: updatedServices,
    };
  });

  const aggregatedInsuranceSummaries = costReviewParts
    .map((part) => part.insuranceCosts)
    .reduce((flattenedInsuranceProviders, insuranceProviders) => [...flattenedInsuranceProviders, ...insuranceProviders], [])
    .reduce((summaries, insuranceProvider) => {
      const existingInsuranceSummary = summaries.find((summary) => summary.insuranceProviderId === insuranceProvider.insuranceProviderId);
      if (!existingInsuranceSummary) {
        summaries.push(insuranceProvider);
        return summaries;
      }
      existingInsuranceSummary.subTotal += insuranceProvider.subTotal;
      return summaries;
    }, []);
  return {
    insuranceCosts: aggregatedInsuranceSummaries,
    providerCosts,
    suggestedShipDate: costReviewParts[0].suggestedShipDate,
    shipFromCount: costReviewParts[0].shipFromCount,
    upsTermsRequired: costReviewParts.some((part) => part.upsTermsRequired),
  };
};

export const launchLabelBatchStatusModalForJob = (jobGuids, fulfillmentPlanSetId, getState, observer) => {
  const modalId = ModalService.launchModal({
    component: LabelBatchStatusContainer,
    props: {
      jobGuids,
      fulfillmentPlanSetId,
      onEndBatchesErrorsAndWarnings: (excluded) => {
        observer.next(batchesErrorsAndWarningsResolution(fulfillmentPlanSetId, excluded, getState));
      },
      onRemoveRow: (fulfillmentPlanIds) => {
        observer.next(
          of(
            removeFulfillmentPlansFromBatch({
              fulfillmentPlanSetId,
              fulfillmentPlanIds,
            }),
          ),
        );
      },
      purchasePostage: (providers, insurances, wallets, tracking, onAddFundsComplete, closeModal) => {
        observer.next(
          of(
            PostagePurchaseActions.postageAndInsurancePurchaseRequest(
              fulfillmentPlanSetId,
              providers,
              insurances,
              wallets,
              tracking,
              onAddFundsComplete,
              closeModal,
            ),
          ),
        );
      },
      deferPostagePurchase: () => {
        observer.next(of(PostagePurchaseActions.postagePurchaseDeferred(fulfillmentPlanSetId)));
      },
    },
    onClose: () => {
      observer.next(of(Actions.setBatchesLbsModalId('')));
      observer.next(of(Actions.batchStatusModalClosed()));
      observer.complete();
    },
  });
  observer.next(of(Actions.setBatchesLbsModalId(modalId)));
};
